<div class="search-container">
  <form class="form-search-bar" [formGroup]="searchForm" (ngSubmit)="handleSubmit()">

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'admin.errors.key-figures' |translate}}</mat-label>
      <mat-select [formControl]="keyFigureControl">
        <mat-option *ngFor="let kf of keyFigures" [value]="kf">{{kf}}</mat-option>
      </mat-select>
    </mat-form-field>

    <button type="reset" mat-raised-button (click)="search.emit('')">Clean</button>
    <button type="submit" mat-raised-button color="primary">Apply</button>
  </form>
</div>
